import React from 'react';
import AudioPlayer from '../components/AudioPlayer';
import Recorder from '../components/Recorder';
import { sleep, isIOS } from '../AppUtils';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { RecordEvent } from '../Analytics';

const recordDuration = 32000;
const song = "audio/cte_music.mp3";

class Step2 extends React.Component {

    constructor(props) {

        super(props);

        this.audioPlayer = new AudioPlayer(null, "playaudio", "play-bar", song);
        
        this.uiInstructions = null;
        this.uiCount = null;
        this.uiLyrics = null;
        this.uiReview = null;
        this.uiRecVideo = null;
        this.uiStep2 = null;

        this.countDown = 3;

        this.recorder =new Recorder(null, "videoIn", "videoOut");

        this.audioInterval = null;

        this.startCountDown = this.startCountDown.bind(this);
        this.startRecord = this.startRecord.bind(this);
        this.review = this.review.bind(this);
        this.prepRecord = this.prepRecord.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {

        var self = this;
        this.audioPlayer.init();

        if (this.context.image == null || this.context.image.size <= 20) {
            alert("There was an error loading your image. Please resubmit your image.");
            this.props.history.push('/');
            RecordEvent("Error-ImageNull");
            return;
        }

        this.uiInstructions = document.getElementById("ui-instructions");
        this.uiCount = document.getElementById("ui-count");
        this.uiLyrics = document.getElementById("ui-lyrics");
        this.uiReview = document.getElementById("ui-review");
        this.uiStep2 = document.getElementById("step2");

        this.uiVideoRecord = document.getElementById("video-record");
        this.uiRecord = document.getElementById("ui-record");
        this.barm = document.getElementById("deskbar");
        this.bard = document.getElementById("mobilebar");
        this.currenttime = document.getElementById("currenttime");
        
        this.uiInstructions.className = "instructions hidden";
        this.uiLyrics.className = "hidden";
        this.uiReview.className = "textcon hidden";

        this.uiVideoRecord.className = "hidden";
        this.barm.className = "hidden";
        this.bard.className = "hidden";

        this.uiRevVideo = document.getElementById("videoOut");
        if (this.uiRevVideo && isIOS) {
            this.uiRevVideo.style = "-webkit-transform:rotate(90deg);"
        }

        this.audioInterval = setInterval(function() {
            var curVal = self.audioPlayer.getNormalizedTime() * 100;
            document.getElementById('play-bar').style.setProperty('width', curVal + '%');
            var sec = parseInt(self.audioPlayer.audio.currentTime % 60);
            var sec0 = ("0" + sec).slice(-2);
            var mmin = parseInt((self.audioPlayer.audio.currentTime / 60) % 60);
            this.currenttime.innerHTML = mmin + ':' + sec0 ;

            if (curVal >= 100) {
                self.audioPlayer.stop();
            }

        }, 100);
    }

    prepRecord() {

        this.uiReview.className = "hidden";
        this.uiStep2.className = "hidden";
        
        if (this.audioInterval != null) {
            clearInterval(this.audioInterval);
        }

        this.audioPlayer.stop();

        this.uiVideoRecord.className = "body-con record";
        this.uiRecord.className = "videoPreviewSelfiecon";

        this.recorder.startRecord(this.startRecord);
    }

    async startRecord(cameraEnabled) {

        if (cameraEnabled === false) {
            this.props.history.push('step2ios');
        }

        this.startCountDown();

        await sleep(recordDuration);

        this.recorder.stopRecord();
        this.audioPlayer.stop();

        this.uiRecord.className = "hidden";
        this.uiReview.className = "textcon";
        this.uiLyrics.className = "hidden";
        this.barm.className = "hidden";
        this.bard.className = "hidden";
    }

    startCountDown() {

        var self = this;

        this.uiInstructions.className = "instructions";

        this.countDown = 3;
        this.uiCount.innerHTML = `${this.countDown}`;

        var countDownTimer = setInterval(() => {
            self.countDown--;
            self.uiCount.innerHTML = `${self.countDown}`;            

            if (self.countDown <= 0) {
                self.uiInstructions.className = "instructions hidden";
                self.uiLyrics.className = "lyrics-con";
                self.barm.className = "progess-bar hidden-mobile";
                self.bard.className = "progess-bar deskhidden";        
                self.audioPlayer.play();
                clearInterval(countDownTimer);
            }
        }, 1000);
    }

    async review() {

        var review = document.getElementById("review");
        var origClassName = "";
        if (review != null) {
            origClassName = review.className;
            review.className = "hidden";
        }

        this.recorder.seekVideo(2.1);
        this.recorder.playRecord();
        await sleep(1000);
        this.audioPlayer.play();
        await sleep(29000);
        
        if (review != null) {
            review.className = origClassName;
        }
    }

    submitForm() {

        this.context.video = this.recorder.getVidBlob();
        this.props.history.push('step3');
        this.audioPlayer.stop();
    }

    playAudio() {
        this.audioPlayer.play();
    }

    render() {

        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu ">
                    <div className="cover"></div>
                    <div className="step-menu-con">
                        <img src="img/sid-menu-img.png" alt="exsample gif" srcSet="" className="side-menu-top"/>
                        <div className="center-gold"></div>
                        <h1 >thank you lord</h1>
                        <h3>enhanced video</h3>

                        <div className="textcon">
                            <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a :25 clip from “Thank You Lord”!</p>
                            <div className="center-gold"></div>
                        </div>

                        <div className="listcon">
                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title">tell us what you’re thankful for!</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber">2</div>
                                </div>
                                <h2 className="step-title"> Show what you are thankful for</h2>
                            </div>

                            <div className="con">
                                <div className="step">
                                    <div className="stepnumber">3</div>
                                </div>
                                <h2 className="step-title"> get your custom music video!</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="step2" className="body-con">
                    <br/>
                    <div className="current-step">
                        <div className="line-before"></div>
                        <div className="con step-con">
                            <div className="step">
                                <div className="stepnumber">2</div>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>
                    <h1 className="main-color listen-step">get ready to record < br className="deskhidden" />your selfie video</h1>
                    <div className="textcon">
                        <p>Listen to the chorus  to practice! </p>
                    </div>
                  
                    <div className="music-play-con">
                        <img src="img/album.png"  srcSet="" className="album-image" alt=""/>

                        <div>
                            <h1 className="main-color songtitle">thank you lord</h1 >
                            <h4 className="songartist"> Chris Tomlin, <br className="hidden-mobile"/> Thomas Rhett <br/> and florida georgia Line</h4>
                            <div className="con-audio">
                                <div id="play-bar" ></div> 
                                <div id="playaudio" onClick={this.playAudio}
                                    data-amplify-analytics-on='click'
                                    data-amplify-analytics-name='click'
                                    data-amplify-analytics-attrs='attr:Step2-PlayAudio'></div>

                                <div id="currenttime" className="prenumber"> 0:00 </div>
                                <div className="postnumber"> 0:28 </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/> 

                    <div className="next-button-con" onClick={this.prepRecord} 
                            data-amplify-analytics-on='click'
                            data-amplify-analytics-name='click'
                            data-amplify-analytics-attrs='attr:Step2-Record'>
                        <div className="line-before"></div>
                        <div className="next-button">
                            <div className="nexr-button-innercon">
                                <div className="next-button-text">record your video</div>
                                <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>
                </div>

                
            
                    <div id="video-record" className="body-con record">
                        <div id="ui-record" className="videoPreviewSelfiecon">
                            <div id="ui-lyrics" className="lyrics-con">
                                <div>
                                    <h2 className="hidden-mobile"> record your video </h2>
                                    <div className="line-after hidden-mobile"></div>
                                    <p className="hidden-mobile">  As soon as you hit record, sing and dance to the chorus—whatever shows how thankful you are!</p>

                                    <span className="lyricstext">Lyrics</span>
                                    <div id="verse">
                                        <div className="animationslide">
                                            For my mama for my friends <br/>
                                            For Your love that never ends<br/>
                                            For the songs that make us dance<br/>
                                            On this ole dirt floor<br/>
                                            For my babies for my girl<br/>
                                            For the way they changed my world<br/>
                                            Waking up today<br/>
                                            I just gotta say<br/>
                                                Thank You Lord<br/>
                                                <br className="deskhidden"/>
                                            I just wanna say<br/>
                                                Thank You Lord
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="ui-instructions" className="instructions">
                                <div>
                                    Starting video in…
                                    <div id="ui-count" className="countdown">1</div>
                                </div>
                            </div>
<div id="deskbar" className="progess-bar hidden-mobile"></div>

                            <video muted playsInline id="videoIn" className="videoPreviewSelfie" ></video>
                        </div>

                        <div id="mobilebar"  className="progess-bar deskhidden"></div>

                        <div id="ui-review" className="textcon">
                
                            <br/>
                            <div className="videoPreviewcon" onClick={this.review} 
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:Step2-Review'>

                                <div id="review" className="con">
                                    <img src="img/play.svg" alt=""/>
                                    <p className="paly-text">Review your video</p>
                                </div>
                    
                                <video muted playsInline id="videoOut" className="videoPreview" poster=""></video>
                            </div>
                
                            <div className="next-button-con hidden" onClick={this.review}
                                data-amplify-analytics-on='click'
                                data-amplify-analytics-name='click'
                                data-amplify-analytics-attrs='attr:Step2-Review'>
                                <div className="next-button ">
                                    <div className="nexr-button-innercon">
                                        <div className="next-button-text">review</div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-absolute">   
                                <div className="next-button-con" onClick={this.prepRecord} 
                                        data-amplify-analytics-on='click'
                                        data-amplify-analytics-name='click'
                                        data-amplify-analytics-attrs='attr:Step2-Redo'>
                                    <div className="next-button">
                                        <div className="nexr-button-innercon">
                                    
                                        <div className="next-button-arrow left"><img src="img/arrow-right.svg" alt=""/></div>
                                        <div className="next-button-text right">redo</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="next-button-con" onClick={this.submitForm}
                                    data-amplify-analytics-on='click'
                                    data-amplify-analytics-name='click'
                                    data-amplify-analytics-attrs='attr:GotoStep3'>
                                    <div className="next-button">
                                        <div className="nexr-button-innercon">
                                            <div className="next-button-text">Next</div>
                                            <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
              
            </div>
        );
    }
}

Step2.contextType = AppContext;
export default withRouter(Step2);